// @flow

import type { Dict } from '../../types/dict';

const getValues = <T, K>(dict: Dict<T, K>): Array<T> => (Object.values(dict): Array<any>);

export default getValues;
